(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if (this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  // Keep main nav always open on desktop — runs after everything loads
  (function keepMainNavOpen() {
    const md = window.matchMedia('(min-width: 768px)');

    function forceOpen() {
      if (!md.matches) return;
      const disc = document.querySelector('.main-menu__disclosure');
      if (disc && !disc.open) disc.open = true;
    }

    // On page load
    document.addEventListener('DOMContentLoaded', forceOpen);
    // Immediately in case DOM is already ready
    forceOpen();
    // On scroll (sticky header may close it)
    window.addEventListener('scroll', forceOpen, { passive: true });
    // On resize / breakpoint change
    window.addEventListener('on:breakpoint-change', forceOpen);
    md.addEventListener('change', forceOpen);

    // MutationObserver: if something removes the open attribute, put it back
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        if (m.attributeName === 'open' && md.matches) {
          const disc = m.target;
          if (!disc.open) disc.open = true;
        }
      });
    });

    function attachObserver() {
      const disc = document.querySelector('.main-menu__disclosure');
      if (disc) {
        observer.observe(disc, { attributes: true, attributeFilter: ['open'] });
      }
    }
    document.addEventListener('DOMContentLoaded', attachObserver);
    attachObserver();
  })();

  } catch(e) { console.error(e); }
})();
})();
